query GetTeamsIntegration {
    loggedInUser {
        id
        microsoftTeamsIntegration {
            isEnabled
            isEnabledForScheduler
            email
        }
    }
}
